import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
import { PainPointsSection } from '../components/PainPointsSection';
import { GallerySection } from '../components/GallerySection';
import { SneakPeekSection } from '../components/SneakPeekSection';
import { BonusBanner } from '../components/BonusBanner';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-dark bg-cream selection:bg-mint/30" data-id="element-278">
      <PurchasePopup data-id="element-279" />
      <Header data-id="element-280" />
      <main data-id="element-281">
        <HeroSection data-id="element-282" />
        <SocialProofBar data-id="element-283" />
        <PainPointsSection data-id="element-284" />
        <GallerySection data-id="element-285" />
        <SneakPeekSection data-id="element-286" />
        <BonusBanner data-id="element-287" />
        <OfferSection data-id="element-288" />
        <TestimonialsSection data-id="element-289" />
        <FAQSection data-id="element-290" />
      </main>
      <Footer data-id="element-291" />
    </div>;
}